module.exports = __webpack_public_path__ + "img/Overview_64x64.9780d8ca.png";